import {useLayoutStore} from '@/store-pinia/layout'
import {usePageTitle} from "@/composables/usePageTitle";

export default defineNuxtRouteMiddleware((to, from) => {
    const pageTitle = usePageTitle()
    pageTitle.value = null
})